import login from './login';

export default {
  language: 'ja',
  country: 'jp',
  name: '日本語',
  embeddedLocale: login,
  flags: ['JP'],
};
